import { put } from 'redux-saga/effects';
import { showDeviceReconfigModal } from '../../actions';

// eslint-disable-next-line import/prefer-default-export
export function* openDeviceReconfigModal() {
  yield put(showDeviceReconfigModal(true));
}
